import { PagePredictionProperties, PageTypes } from '@shared/types';
export function isPageUndefined(page) {
    return page.predictions[PagePredictionProperties.type] === PageTypes.undefined;
}
